import { render } from "./currency-settings-modal.vue?vue&type=template&id=436cf552"
import script from "./currency-settings-modal.vue?vue&type=script&lang=js"
export * from "./currency-settings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__